/* Core & libraries */
import React from "react";
import { useTheme } from "react-jss";
import { FormattedMessage } from "react-intl";

/* Helpers, constants, custom methods, internal libraries */
import DynamicImageLoader from "../dynamicImageLoader";

/* Components */

/* Styles */
import styles from "./styles.js"


const BookingsHeader = () => {
  const theme = useTheme();
  const classes = styles({ theme });

  return (
    <div className={classes.bookingsWrapper}>
      <div className={classes.logo}>
        <DynamicImageLoader imageName={"plane-icon.svg"} />
      </div>
      <h1><FormattedMessage id="reportsNoBookings.title"/></h1>
      <p><FormattedMessage id="reportsNoBookings.description"/></p>
    </div>
  )
}

export default BookingsHeader;
